'use strict';
import * as $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dReal from "./app.layouts.-Main-Layout$-Display-Name$3$-Real.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$DisplayName$3$Real$(outer) {
  this.Lapp_layouts_MainLayout$DisplayName$3$Real$__f_$outer = null;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lapp_layouts_MainLayout$DisplayName$3$Real$__f_$outer = outer;
}
export { $c_Lapp_layouts_MainLayout$DisplayName$3$Real$ as $c_Lapp_layouts_MainLayout$DisplayName$3$Real$ };
$c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype.constructor = $c_Lapp_layouts_MainLayout$DisplayName$3$Real$;
/** @constructor */
function $h_Lapp_layouts_MainLayout$DisplayName$3$Real$() {
}
export { $h_Lapp_layouts_MainLayout$DisplayName$3$Real$ as $h_Lapp_layouts_MainLayout$DisplayName$3$Real$ };
$h_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype = $c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype;
$c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype.apply__T__Lapp_layouts_MainLayout$DisplayName$3$Real = (function(name) {
  return new $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dReal.$c_Lapp_layouts_MainLayout$DisplayName$3$Real(this.Lapp_layouts_MainLayout$DisplayName$3$Real$__f_$outer, name);
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype.toString__T = (function() {
  return "Real";
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype.fromProduct__s_Product__Lapp_layouts_MainLayout$DisplayName$3$Real = (function(x$0) {
  var name$2 = x$0.productElement__I__O(0);
  return new $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00243$0024$002dReal.$c_Lapp_layouts_MainLayout$DisplayName$3$Real(this.Lapp_layouts_MainLayout$DisplayName$3$Real$__f_$outer, name$2);
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Real$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_layouts_MainLayout$DisplayName$3$Real(p);
});
var $d_Lapp_layouts_MainLayout$DisplayName$3$Real$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$DisplayName$3$Real$, "app.layouts.MainLayout$DisplayName$3$Real$", ({
  Lapp_layouts_MainLayout$DisplayName$3$Real$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_layouts_MainLayout$DisplayName$3$Real$ as $d_Lapp_layouts_MainLayout$DisplayName$3$Real$ };
//# sourceMappingURL=app.layouts.-Main-Layout$-Display-Name$3$-Real$.js.map
